import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DeleteAllLeadSubscriptionContentsMutation,
  DeleteAllLeadSubscriptionContentsMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const deleteAllLeadSubscriptionContentsMutation = graphql(`
  mutation deleteAllLeadSubscriptionContents {
    deleteAllLeadSubscriptionContents
  }
`);

export function useDeleteAllLeadSubscriptionContents(
  options?: UseMutationOptions<
    DeleteAllLeadSubscriptionContentsMutation,
    unknown,
    DeleteAllLeadSubscriptionContentsMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(deleteAllLeadSubscriptionContentsMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptionContents"] });
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptions"] });
      options?.onSuccess && options?.onSuccess(data, variables, context);
    },
  });
  return { data: data?.deleteAllLeadSubscriptionContents, ...rest };
}
